import store from "@/store";

const crm_router = [
  {
    path: "/:lang?/auth",
    name: "auth",
    component: () => import("../views/SignIn.vue"),
    beforeEnter: async (to, from, next) => {
      let responce = await store.dispatch("AdminCkeck");

      if (responce == true) {
        next({
          name: "dashboard",
        });
      } else {
        next();
      }
    },
  },
  {
    path: `/:lang?/admin`,
    name: "dashboard",
    component: () => import("../views/Dashboard.vue"),
    beforeEnter: async (to, from, next) => {
      let responce = await store.dispatch("AdminCkeck");

      if (responce == true) {
        next();
      } else {
        next({
          name: "auth",
        });
      }
    },
    children: [
      {
        path: "leads",
        name: "leads-crm",
        component: () => import("../views/CRM/1.Leads.vue"),
      },
      {
        path: "content",
        name: "content-crm",
        component: () => import("../views/CRM/2.Content.vue"),
      },
      {
        path: "rules",
        name: "rules-crm",
        component: () => import("../views/CRM/3.Rules.vue"),
      },
      {
        path: "blog",
        name: "blog-crm",
        component: () => import("../views/CRM/4.Blog.vue"),
      },
      {
        path: "new_blog",
        name: "new-blog-crm",
        component: () => import("../views/CRM/NewBlogNews.vue"),
      },
      {
        path: "webcam_access",
        name: "webcam_access-crm",
        component: () => import("../views/CRM/5.WebCam.vue"),
      },
      {
        path: "webcam_manage",
        name: "webcam_manage-crm",
        component: () => import("../views/CRM/6.WebManage.vue"),
      },
      {
        path: "B_B",
        name: "B_B-crm",
        component: () => import("../views/CRM/7.Settings.vue"),
      },
      {
        path: "settings",
        name: "settings-crm",
        component: () => import("../views/CRM/7.Settings.vue"),
      },
    ],
  },
];

export default crm_router;
